import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.scss";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import {
  faFacebook,
  faInstagram,
  faReddit,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

const MobileMenu = () => {
  const [menuState, setMenuState] = useState(false);
  const toggleMenu = () => setMenuState(!menuState);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  return (
    <div className="mobileMenu" style={{display: windowWidth < 800 ? 'flex' : 'none'}}>
      <div className="menu" style={{ display: menuState ? "flex" : "none" }} onClick={()=>{setMenuState(false)}}>
        <div className="m-header">
          <div className="m-socials">
            <FontAwesomeIcon
              className="social-icon md hydrated"
              onClick={()=>window.open('https://www.instagram.com/rouse_drink', '_BLANK', 'noopener noreferrer')}
              icon={faInstagram}
            />
            <FontAwesomeIcon
              className="social-icon md hydrated"
              icon={faFacebook}
              onClick={()=>window.open('https://www.facebook.com/rousedrink', '_BLANK', 'noopener noreferrer'  )}
            />
            <FontAwesomeIcon
              className="social-icon md hydrated"
              onClick={()=>window.open('https://www.tiktok.com/@rousedrink', '_BLANK', 'noopener noreferrer')}
              icon={faTiktok}
            />
            <FontAwesomeIcon
              className="social-icon md hydrated"
              onClick={()=>window.open('https://www.reddit.com/r/rousedrink/', '_BLANK', 'noopener noreferrer')}
              icon={faReddit}
            />
          </div>
          <FontAwesomeIcon
            className="m-close"
            icon={faClose}
            onClick={() => setMenuState(false)}
          />
        </div>
        <div className="m-nav">
          <a className="m-navlink" style={{ backgroundColor: '#4E2272' }} href="https://therouseco.com/#">
            Enjoy Sex and Stay Hydrated
          </a>
          <a
            className="m-navlink"
            style={{ backgroundColor: '#eb1478' }}
            href="https://www.indiegogo.com/projects/f-it-first-rehydration-drink-for-sex-by-rouse/reft/38212726/website"
            target="_blank"
            rel="noopener noreferrer"
          >
            Be a Rouser – Indiegogo
          </a>
          <a className="m-navlink" href="https://therouseco.com/#thedrink">
            The Drink
          </a>
          <a className="m-navlink" href="https://therouseco.com/#quest">
            Unreal Purpose
          </a>
          <a className="m-navlink" href="https://therouseco.com/#health">
            Don't Fuck With Your Health
          </a>
          <a className="m-navlink" href="https://therouseco.com/#join">
            Let's Get Intimate
          </a>
          <a className="m-navlink" href="https://therouseco.com/fund#">
            For Investors
          </a>
          <a className="m-navlink" href="https://therouseco.com/partner#">
            For Retail Partners
          </a>
          <a className="m-navlink" href="https://therouseco.com/join#">
            Join for the Community
          </a>
          <a className="m-navlink" href="https://therouseco.com/terms#">
            Terms & Conditions
          </a>
        </div>
      </div>
      <div className="m-button" onClick={toggleMenu}>
        <FontAwesomeIcon icon={faBars} />
      </div>
    </div>
  );
};

export default MobileMenu;
